import { Component, Input, OnInit } from '@angular/core';
import { baseUrls } from 'src/app/appConstant';

@Component({
  selector: 'app-travel-card',
  templateUrl: './travel-card.component.html',
  styleUrls: ['./travel-card.component.scss']
})
export class TravelCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // console.log('travelCardInfo_ngOnInit', this.travelCardInfo);
  }
  @Input('travelCardInfo')travelCardInfo;
  baseUrl = baseUrls;
  rate = 4;

  openInNewTab(itemInfoPassed){
    console.log('openInNewTab', itemInfoPassed);
    if(itemInfoPassed?.categoryName == "Retreats"){
      window.open(this.baseUrl?.hostedUrl + 'travel/destinations/' +itemInfoPassed?.region.slug +'/' +itemInfoPassed?.country.slug+"/retreats/"+ itemInfoPassed?.slug)
    } 
    if(itemInfoPassed?.categoryName == "Tours"){
      window.open(this.baseUrl?.hostedUrl + 'travel/destinations/' +itemInfoPassed?.region.slug +'/' +itemInfoPassed?.country.slug+"/tours/"+ itemInfoPassed?.slug)
    } 
    if(itemInfoPassed?.categoryName == "Hotels & Resorts"){
      window.open(this.baseUrl?.hostedUrl + 'travel/destinations/' +itemInfoPassed?.region.slug +'/' +itemInfoPassed?.country.slug+"/hotels-resorts/"+ itemInfoPassed?.slug)
    } 
  }
}
